import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ug-CN'
import '../element-variables.scss'

Vue.use(Element, { locale })